import type { MasterDataRow } from '../../datagovernance/framework';

type Props = { items?: MasterDataRow[] };

export function MasterDataPanel({ items = [] }: Props) {
  return (
    <div className="space-y-2">
      {items.map((item) => (
        <div key={item.entity} className="rounded-lg border border-slate-200 p-3 dark:border-slate-700">
          <div className="flex items-center justify-between gap-3">
            <div>
              <p className="text-sm font-medium">{item.entity}</p>
              <p className="text-xs text-slate-500">{item.owner}</p>
            </div>
            <div className="text-right">
              <p className="text-lg font-semibold text-brand-600">{item.records.toLocaleString()}</p>
              <p className="text-xs text-slate-500">{item.status}</p>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
